import {BaseContainerModel} from '../base-container.model';
import {bl_fi_country_hdr_RowClass} from '../../dbschema';

export class CountryContainerModel extends BaseContainerModel {
  bl_fi_country_hdr: bl_fi_country_hdr_RowClass = new bl_fi_country_hdr_RowClass();
}
